import React, { useState, useEffect } from "react";

import HeaderMenuProfile from "../../header/HeaderMenuProfile.js";

import AuthService from "../../../../class/services/AuthService";

import Bet_history_menu from "./bet_history_menu.js";

import Bet_history_cupon from "./bet_history_cupon.js";

import Bet_history_casino from "./bet_history_casino.js";

const Bet_history = () => {
  const [selection, setSelection] = useState("sport");

  //ЗРОБИТИ ЩОБ ВСЕ БРАЛОСЯ З КОНФІГА game_slugs={['casino', 'casino-live', 'crash-game']} limit="2"  НА CMS

  return (
    <div>
      <Bet_history_menu setSelection={setSelection} />

      <div className="tab-content" id="myTabContent">
        {selection === "sport" && <Bet_history_cupon />}
        {selection === "casino" && <Bet_history_casino />}
      </div>
    </div>
  );
};

export default Bet_history;
